export const _en = {
    addButton: {
        label: "Add a new profile"
    },
    toggleDeleted: {
        label: "Show deleted data"
    },
    dialog: {
        add: {
            title: "Add a new profile",
            buttons: {
                save: "Save",
                cancel: "Cancel"
            }
        }
    },
    description: {
        label: "Description"
    },
    name: {
        label: "Name"
    },
    isSelfScoped: {
        label: "Self scoped"
    },
    profileConfigurationId: {
        label: "Profile composition"
    },
    profilePageAccessConfigurationId: {
        label: "Profile access"
    },
    maxAge: {
        label: "Max idle time"
    },
    autoRefresh: {
        label: "Auto refresh"
    },
    showAllTemplates: {
        label: "Show all view templates"
    }
};


export const _fr = {
    addButton: {
        label: "Profil"
    },
    toggleDeleted: {
        label: "Afficher les profils supprimés"
    },
    dialog: {
        add: {
            title: "Ajouter un profil",
            buttons: {
                save: "Sauvegarder",
                cancel: "Annuler"
            }
        }
    },
    description: {
        label: "Description"
    },
    name: {
        label: "Nom"
    },
    isSelfScoped: {
        label: "Données centrées sur l'utilisateur"
    },
    profileConfigurationId: {
        label: "Composition du profil"
    },
    profilePageAccessConfigurationId: {
        label: "Accès du profil"
    },
    maxAge: {
        label: "Durée d'inactivité maximum"
    },
    autoRefresh: {
        label: "Rafraichissement automatique"
    },
    showAllTemplates: {
        label: "Afficher toutes les vues enregistrées publiées"
    }
};